module.exports = __webpack_public_path__ + "static/media/NSWGov_Waratah_Primary_RGB.8c96bac7.jpg";